var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 315,
    viewBox: "0 0 315 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 157.5,
    r: 124.049,
    fill: "url(#paint0_linear_1230_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.691 191.067C193.952 193.379 183.786 193.267 174.102 190.742C164.417 188.217 155.518 183.357 148.2 176.599C140.883 169.841 135.375 161.394 132.171 152.016C128.967 142.638 128.166 132.621 129.84 122.862C129.586 123.105 129.317 123.333 129.035 123.545C127.04 125.045 124.547 125.601 119.559 126.714L115.035 127.728C97.5072 131.65 88.7435 133.607 86.6558 140.234C84.5753 146.853 90.5461 153.761 102.495 167.569L105.587 171.139C108.978 175.062 110.681 177.026 111.444 179.449C112.206 181.878 111.95 184.498 111.437 189.729L110.966 194.497C109.164 212.925 108.259 222.135 113.717 226.226C119.174 230.325 127.382 226.593 143.784 219.121L148.038 217.192C152.697 215.065 155.027 214.009 157.5 214.009C159.972 214.009 162.302 215.065 166.969 217.192L171.208 219.121C187.617 226.586 195.825 230.318 201.276 226.233C206.741 222.135 205.836 212.925 204.033 194.497L203.691 191.067Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.153 111.081L134.816 115.222C132.251 119.771 130.968 122.045 128.973 123.545C129.258 123.334 129.522 123.109 129.778 122.862C128.104 132.622 128.904 142.64 132.109 152.019C135.313 161.398 140.822 169.845 148.14 176.603C155.459 183.362 164.359 188.221 174.044 190.745C183.729 193.269 193.897 193.38 203.636 191.068L203.494 189.73C202.988 184.498 202.731 181.878 203.494 179.449C204.256 177.027 205.952 175.062 209.35 171.14L212.443 167.57C224.391 153.768 230.362 146.86 228.274 140.234C226.194 133.608 217.43 131.643 199.903 127.728L195.371 126.714C190.391 125.601 187.897 125.045 185.895 123.545C183.9 122.045 182.617 119.771 180.052 115.222L177.722 111.081C168.695 95.0828 164.185 87.0835 157.438 87.0835C150.69 87.0835 146.18 95.0828 137.153 111.081Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1230_2",
    x1: -508.771,
    y1: -264.018,
    x2: 681.786,
    y2: 578.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE46E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumBadge);
export default __webpack_public_path__ + "static/media/premium_badge.5867369a7af3c1c87d07abd88232e5b0.svg";
export { ForwardRef as ReactComponent };